/* import __COLOCATED_TEMPLATE__ from './company-default-logo-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();